import { Alert, AlertTitle, Button, Snackbar, Stack } from "@mui/material";
import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AddAd from "./AddPost";
import AddUrlAd from "./AddUrlAd";
import { IoIosArrowBack } from "react-icons/io";
import { setToast } from "../redux/actions/ToastAction";
import AdvertisingStyles from "../assets/styles/advertising";
import { differenceInDays } from "date-fns/esm";

const Advertising = () => {
  const [value, setValue] = useState(0);
  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();

  const navigate = useHistory();

  // redux

  const currUser = useSelector(
    (state) => (state.reducer.user ? state.reducer.user : {}),
    shallowEqual
  );

  const toastHandler = () => {
    dispatch(setToast(false, "success", "Успешно Изменено"));
  };
  return (
    <AdvertisingStyles>
      <Snackbar
        open={reducer.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer.severity}
          sx={{ width: "100%" }}
        >
          {reducer.content}
        </Alert>
      </Snackbar>
      <Button
        onClick={() => navigate.push(`/`)}
        variant="outlined"
        startIcon={<IoIosArrowBack />}
        style={{
          padding: "12px 22px",
          borderRadius: "40px",
          fontWeight: "bold",
        }}
      >
        Отменить и назад
      </Button>
      <>
        <Stack
          direction="row"
          spacing={2}
          sx={{ my: 3 }}
          className="col-lg-4 justify-content-start p-0"
        >
          <Button
            variant={value === 0 ? "contained" : "outlined"}
            className="col-6"
            style={{
              background: value === 0 ? "var(--main-color)" : "",
              fontWeight: value === 0 ? "bold" : "normal",
              padding: "8px 18px",
              borderRadius: "40px",
            }}
            onClick={() => setValue(0)}
          >
            Контекстная
          </Button>
          <Button
            variant={value === 1 ? "contained" : "outlined"}
            className="col-6"
            style={{
              background: value === 1 ? "var(--main-color)" : "",
              fontWeight: value === 1 ? "bold" : "normal",
              padding: "12px 22px",
              borderRadius: "40px",
            }}
            onClick={() => setValue(1)}
          >
            Пост
          </Button>
        </Stack>
        {value === 1 ? (
          <AddAd />
        ) : !currUser?.resAdvertisingTariff ||
          currUser?.countKey === 0 ||
          differenceInDays(new Date(currUser?.tariffExpireDate), new Date()) <=
            0 ? (
          <Alert severity="error" className="my-3">
            <AlertTitle>
              Срок действия вашего тарифа или ключевые слова истекли, или вы еще
              не выбрали тариф.
            </AlertTitle>{" "}
            Купить новый тариф для размещения рекламы.
          </Alert>
        ) : (
          <AddUrlAd />
        )}
      </>
    </AdvertisingStyles>
  );
};

export default Advertising;
